import { OutOfPageAdType } from '../..'

/**
 * https://developers.google.com/ad-placement/docs/ad-rate
 */
export const AD_BREAK_MAXIMUM_FREQUENCY_RATE = '30s'

export const AD_SENSE_CLIENT_ID = 'ca-pub-2864899775153797'

export const OUT_OF_PAGE_AD_TYPES_SUPPORTED_BY_AD_SENSE_PROVIDER = [
    'interstitial',
    'interstitial_preroll',
    'rewarded',
] as const

export type OUT_OF_PAGE_AD_TYPES_SUPPORTED_BY_AD_SENSE_PROVIDER =
    (typeof OUT_OF_PAGE_AD_TYPES_SUPPORTED_BY_AD_SENSE_PROVIDER)[number]

export const isSupportedOutOfPageAdType = (
    type: OutOfPageAdType,
): type is OUT_OF_PAGE_AD_TYPES_SUPPORTED_BY_AD_SENSE_PROVIDER =>
    OUT_OF_PAGE_AD_TYPES_SUPPORTED_BY_AD_SENSE_PROVIDER.includes(
        type as OUT_OF_PAGE_AD_TYPES_SUPPORTED_BY_AD_SENSE_PROVIDER,
    )
